import { getJobName, jobs } from "@/constants/areas";
import { Col, Row } from "antd";
import { useCallback, useState } from "react";
import HBInput from "../HBInput";
import HBSelect from "../HBInput/select";

export default function JobSelect({
  value,
  onChange,
  selectStyle = {},
  inputStyle = {},
  selectCol = 12,
  inputCol = 12,
  inputPlaceholder = "请输入",
  ...props
} = {}) {
  const otherJob = value?.id == 999;
  const [inputVisible, setInputVisible] = useState(otherJob);
  const [inputValue, setInputValue] = useState(value?.name);
  const [selectValue, setSelectValue] = useState(value?.id);

  const selectValueChange = useCallback(
    (value) => {
      if (value == 999) {
        setInputVisible(true);
        onChange({
          id: value,
          name: "",
        });
        setInputValue("");
      } else {
        setInputVisible(false);
        onChange({ id: value, name: getJobName(value) });
      }
      setSelectValue(value);
    },
    [onChange]
  );

  const inputValueChange = useCallback(
    (event) => {
      onChange({
        id: 999,
        name: event.target.value,
      });
      setInputValue(event.target.value);
    },
    [onChange]
  );

  return (
    <Row gutter={[20, 12]}>
      <Col span={selectCol}>
        <HBSelect
          options={jobs.map(({ id, jobName }) => ({ id, name: jobName }))}
          optValue="id"
          optLabel="name"
          optKey="id"
          onChange={selectValueChange}
          style={selectStyle}
          value={selectValue}
          {...props}
        />
      </Col>
      {inputVisible && (
        <Col span={inputCol}>
          <HBInput
            value={inputValue}
            onChange={inputValueChange}
            {...props}
            style={inputStyle}
            placeholder={inputPlaceholder}
          ></HBInput>
        </Col>
      )}
    </Row>
  );
}
